var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 224,
    viewBox: "0 0 404 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_900_77677)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 283.12,
    height: 177.961,
    rx: 20,
    transform: "matrix(0.874155 -0.485647 0.874155 0.485647 0 137.496)",
    fill: "url(#paint0_linear_900_77677)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.874155,
    width: 282.12,
    height: 176.961,
    rx: 19.5,
    transform: "matrix(0.874155 -0.485647 0.874155 0.485647 0.110008 137.921)",
    stroke: "url(#paint1_linear_900_77677)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.293 161.255C148.736 162.717 145.672 163.875 142.294 164.656C139.212 165.344 135.887 165.604 132.611 165.411C129.262 165.173 126.096 164.456 123.425 163.329L129.77 158.608C132.422 159.492 135.137 159.8 137.915 159.531C140.69 159.26 143.254 158.505 145.232 157.376C146.39 156.735 147.357 155.996 148.095 155.187C148.802 154.451 149.181 153.634 149.198 152.805C149.208 152.423 149.076 152.045 148.811 151.696C148.546 151.346 148.153 151.031 147.657 150.771C147.293 150.567 146.867 150.399 146.398 150.274C145.921 150.129 145.393 150.044 144.847 150.023C144.174 150.003 143.498 150.05 142.849 150.162C141.964 150.304 141.109 150.502 140.3 150.751L127.718 154.611C126.784 154.905 125.636 155.22 124.276 155.555C122.869 155.89 121.387 156.111 119.874 156.211C118.165 156.32 116.441 156.224 114.817 155.932C113.061 155.616 111.302 154.968 109.54 153.987C107.059 152.608 105.632 151.109 105.26 149.489C104.903 147.829 105.402 146.138 106.698 144.612C108.129 142.9 110.122 141.348 112.573 140.036C114.945 138.706 117.749 137.638 120.831 136.893C123.616 136.232 126.634 135.955 129.628 136.084C132.766 136.232 135.789 136.777 138.466 137.677L132.061 142.66C130.698 142.17 129.124 141.886 127.491 141.835C125.931 141.794 124.368 141.95 122.919 142.291C121.465 142.624 120.131 143.105 118.986 143.707C117.869 144.283 116.952 144.967 116.281 145.724C115.658 146.385 115.326 147.117 115.313 147.858C115.315 148.189 115.435 148.515 115.665 148.818C115.896 149.121 116.232 149.395 116.656 149.623C117.005 149.832 117.427 149.999 117.896 150.115C118.366 150.232 118.874 150.294 119.391 150.3C120.463 150.286 121.522 150.152 122.507 149.908C123.585 149.656 124.632 149.364 125.641 149.033L133.931 146.379C135.169 145.98 136.586 145.569 138.2 145.146C139.835 144.709 141.567 144.4 143.346 144.226C145.217 144.026 147.138 144.069 148.958 144.352C150.888 144.628 152.786 145.286 154.654 146.323C156.509 147.308 157.861 148.55 158.574 149.926C159.215 151.201 159.311 152.546 158.856 153.856C158.356 155.228 157.44 156.547 156.149 157.757C154.815 159.035 153.182 160.212 151.293 161.255V161.255Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.135 148.82L135.168 128.282L161.783 113.496L168.302 117.118L148.801 127.951L156.709 132.345L172.539 123.55L179.06 127.173L163.231 135.968L172.728 141.244L192.229 130.41L198.75 134.033L172.135 148.82Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.184 130.457L168.217 109.92L175.437 105.909L216.457 110.503L191.813 96.8109L199.033 92.7995L236 113.337L228.78 117.348L187.759 112.754L212.404 126.446L205.184 130.457Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.714 84.6072L272.67 76.2498L237.875 71.2207L246.195 66.5982L268.268 69.7929L262.518 57.53L270.836 52.909L279.891 72.2384L294.934 80.5959L287.714 84.6072Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220.95 80.7409C215.209 83.7686 208.536 87.5394 208.536 87.5394L216.37 91.6705C216.37 91.6705 224.952 86.3246 228.59 84.9854C232.229 83.6463 241.422 82.0389 248.446 85.9408C255.469 89.8428 252.711 95.0285 250.358 97.0787C248.005 99.1289 238.498 103.887 238.498 103.887L245.782 107.934C245.782 107.934 252.296 104.373 257.759 101.19C263.222 98.0079 270.539 89.6387 256.165 81.6526C241.79 73.6666 226.694 77.7147 220.95 80.7409Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.695 90.7461L208.527 87.526L213.273 93.6499L231.195 95.4688L234.716 105.562L245.769 107.925L239.695 90.7461L239.698 90.7447L239.695 90.7461Z",
    fill: "#00B4F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_900_77677",
    x: 1.24219,
    y: -3.31055,
    width: 400.572,
    height: 230.543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_900_77677"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_900_77677",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_900_77677",
    x1: -89.0059,
    y1: -124.097,
    x2: -53.6188,
    y2: 204.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667914,
    stopColor: "#F9F9F9",
    stopOpacity: 0.175336
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_900_77677",
    x1: -5.56696,
    y1: -5.79264e-7,
    x2: 52.355,
    y2: 233.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTop);
export default __webpack_public_path__ + "static/media/cardTop.66c12ab299d8a58e62641a150806b649.svg";
export { ForwardRef as ReactComponent };